import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import Card from "../Reusable/Card";
import { useForm } from "react-hook-form";
import ComboboxInput from "../Reusable/ComboboxInput";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
import MultipleSelectField from "../Reusable/MultiSelectField";
import DeliveryChargeTable from "../DeliveryCharge/DeliveryChargeTable";
import useGetHook from "../../customHooks/useGetHook";
const DeliveryChargeList = (props: any) => {
  const { defaultBranch, serviceTypeData, productTypeData } = props;
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({
    defaultValues: {
      local_branch: defaultBranch,
      local_service: serviceTypeData?.[0],
      product_type: productTypeData?.map((item: Record<string, string>) => ({
        label: item?.name,
        value: item?.id,
      })),
    },
  });

  const localServiceBranch = watch("local_branch");
  const localServiceType = watch("local_service");
  const localProductType = watch("product_type");

  const branchId = localServiceBranch?.id || localServiceBranch;

  const { data: selectedBranch } = useGetHook({
    queryKey: ["branch", branchId],
    url: `${APIS.BRANCH}${branchId}/`,
    params: {},
    enabled: !!branchId,
  });
  const serviceTypeId = localServiceType?.id || localServiceType;

  const { data: selectedServiceType } = useGetHook({
    queryKey: ["service-type", serviceTypeId],
    url: `${APIS.SERVICE_TYPE}${serviceTypeId}/`,
    params: {},
    enabled: !!serviceTypeId,
  });
  return (
    <>
      <Card title={`Rate List`}>
        <div className={tw`w-full grid grid-cols-3 gap-x-6`}>
          <ComboboxInput
            url={APIS.BRANCH}
            props={{ is_active: true }}
            queryKey={"local-branch"}
            register={register("local_branch")}
            errors={errors?.local_branch}
            name={"local_branch"}
            label={"Service Branch"}
            setValue={setValue}
            placeholder={"Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{ is_active: true }}
            queryKey={"local-service"}
            register={register("local_service")}
            errors={errors?.local_service}
            name={"local_service"}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <MultipleSelectField
            label={"Product Type"}
            queryKey={"product-type"}
            register={register("product_type")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
            }}
            url={APIS.PRODUCT_TYPE}
            value={
              productTypeData
                ? productTypeData.map((item: Record<string, string>) => ({
                    label: item?.name,
                    value: item?.id,
                  }))
                : []
            }
          />
        </div>
      </Card>
      <Card title={`Rate Format`}>
        {localServiceBranch &&
        localServiceType &&
        localProductType?.length !== 0 &&
        localProductType ? (
          <DeliveryChargeTable
            localServiceBranch={localServiceBranch}
            localServiceType={localServiceType}
            localProductType={localProductType}
            merchantId={null}
            selectedBranch={selectedBranch}
            selectedServiceType={selectedServiceType}
            id={"942bc048-5494-4557-9121-464a169d33a0"}
          />
        ) : (
          <>
            {" "}
            <p>Please select Service Branch And Service type</p>
          </>
        )}
      </Card>
    </>
  );
};

export default DeliveryChargeList;
